import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse } from "@api";
import type { IReclaimSalesInvoiceReturnDto } from "@api/stores/salesInvoices/returns/reclaim/types";

import type { IPathBaseParam } from "./path";

const postApis = createPostApi<
  IApiResponse<unknown>,
  IPathBaseParam,
  IReclaimSalesInvoiceReturnDto
>("stores.salesInvoices.returns.reclaim");

export const reclaim = {
  ...postApis,
};
